import api from '../../utils/api';

export interface AppTrackingSummaryRow {
  day: string;
  install_count: number;
  uninstall_count: number;
  net_growth: number;
}

export interface AppTrackingSummaryResponse {
  success: boolean;
  data: {
    from: string;
    to: string;
    rows: AppTrackingSummaryRow[];
  };
}

export interface TimeSpentRow {
  screen_name?: string;
  service_name?: string;
  sessions_count: number;
  avg_duration_ms: number;
  median_duration_ms: number;
}

export interface TimeSpentResponse {
  success: boolean;
  data: {
    from: string;
    to: string;
    screens: TimeSpentRow[];
    services: TimeSpentRow[];
  };
}

function toIsoDate(date: Date): string {
  return date.toISOString();
}

export async function fetchAppTrackingSummary(from: Date, to: Date): Promise<AppTrackingSummaryResponse['data']> {
  const response = await api.get<AppTrackingSummaryResponse>('/master-admin/analytics/app-tracking/summary', {
    params: {
      from: toIsoDate(from),
      to: toIsoDate(to),
    },
  });
  return response.data.data;
}

export async function fetchAppTrackingTimeSpent(from: Date, to: Date): Promise<TimeSpentResponse['data']> {
  const response = await api.get<TimeSpentResponse>('/master-admin/analytics/app-tracking/time-spent', {
    params: {
      from: toIsoDate(from),
      to: toIsoDate(to),
    },
  });
  return response.data.data;
}

